import { DATE_FORMAT } from './../constants/constant';
import { FormControl } from '@angular/forms';
import * as moment from 'moment';

export function DateValidator(format = DATE_FORMAT): any {
  return (control: FormControl): { [key: string]: any } => {
    const date = moment(control.value, format, true);
    const minDate = moment('1753-01-02 00:00:00.000').startOf('day');
    const currentDate = moment().startOf('day');
    if (control.value && control.value !== null && control.value !== undefined) {
      if (!date.isValid()) {
        return { invalidDate: true };
      }
      if (date.diff(minDate, 'hours') < 0) {
        return { invalidMinDate: true };
      }
    }

    return null;
  };
}

export function DateValidatorWithDate(format = DATE_FORMAT): any {
  return (control: FormControl): { [key: string]: any } => {
    const val = control.value;
    const formattedDate = moment(control.value, format, true).startOf('day');
    const currentDate = moment().startOf('day');
    const minDate = moment('1753-01-02 00:00:00.000').startOf('day');
    if (val && !formattedDate.isValid()) {
      return { invalidDate: true };
    }
    if (formattedDate.diff(minDate, 'hours') < 0) {
      return { invalidMinDate: true };
    }

    return null;
  };
}

export function DateValidatorWithFutureDate(format = DATE_FORMAT): any {
  return (control: FormControl): { [key: string]: any } => {
    const val = control.value;
    const formattedDate = moment(control.value, format, true).startOf('day');
    const currentDate = moment().startOf('day');
    const minDate = moment('1753-01-02 00:00:00.000').startOf('day');

    if (val && !formattedDate.isValid()) {
      return { invalidDate: true };
    }
    if (formattedDate.diff(minDate, 'hours') < 0) {
      return { invalidMinDate: true };
    }
    if (currentDate.diff(formattedDate, 'hours') < 0) {
      return { invalidDateRange: true };
    }

    return null;
  };
}
